import { CategorySection } from '@varo/graphql-schema-types';
import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import { EmptyStateScreen } from 'shared/patterns/vxl/EmptyStateScreen/EmptyStateScreen';
import theme from 'shared/styles/theme';

import { ScrollPersistenceResult } from './hooks/useScrollPersistence';
import OffersList from './OffersList';

interface CategoryContentProps {
  categoryName: string;
  selectedCategoryId?: string | null;
  listRef: React.RefObject<FlatList | null>;
  translatedText: (key: string) => string;
  sections: CategorySection[];
  isLoading: boolean;
  hasData: boolean;
  hidePills: boolean;
  coords?: { latitude: number; longitude: number } | null;
  onScroll: ScrollPersistenceResult['handleScroll'];
  onContentSizeChange: () => void;
}

const CategoryContent = ({
  categoryName,
  selectedCategoryId,
  listRef,
  translatedText,
  sections,
  isLoading,
  hasData,
  coords,
  hidePills,
  onScroll,
  onContentSizeChange,
}: CategoryContentProps) => {
  const hasVendors = sections.some((s) => (s.vendors?.length ?? 0) > 0);
  const shouldShowEmptyState = !isLoading && hasData && !hasVendors;

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <LoadingSpinner />
      </View>
    );
  }

  return (
    <>
      {hasVendors ? (
        <OffersList
          ref={listRef}
          sections={sections}
          selectedCategoryName={categoryName}
          isLoading={isLoading}
          coords={coords}
          hidePills={hidePills}
          selectedCategoryId={selectedCategoryId}
          onScroll={onScroll}
          onContentSizeChange={onContentSizeChange}
        />
      ) : null}

      {shouldShowEmptyState ? (
        <EmptyStateScreen
          headlineText={translatedText('noOffersTitle')}
          bodyText={translatedText('noOffersMessage')}
          illustrationKey="OFFERS_B"
          analyticsId={translatedText('errorAnalyticsKey')}
        />
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacing.xl,
  },
});

export default CategoryContent;
